import { Component, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RequestSentDialogComponent } from './request-sent-dialog/request-sent-dialog.component';
import { pageSeoInfo } from '../../../constants/page-seo-info';
import { SeoService } from '../../../services/seo.service';

@Component({
  selector: 'app-request-sent',
  standalone: true,
  imports: [],
  templateUrl: './request-sent.component.html',
  styleUrl: './request-sent.component.scss',
})
export class RequestSentComponent implements OnInit {
  constructor(
    private matDialog: MatDialog,
    private seoService: SeoService,
    @Optional() private matDialogRef: MatDialogRef<RequestSentComponent> | null
  ) {
    if (matDialogRef) matDialogRef.disableClose = true;
  }
  ngOnInit(): void {
    this.matDialog.open(RequestSentDialogComponent, {
      panelClass: 'request-sent-dialog',
      maxWidth: '25.375rem',
      width: '100%',
    });
    const { title, description, canonicalUrl } = pageSeoInfo['requestAccess'];
    this.seoService.setPageTitle(title);
    this.seoService.setPageDescription(description);
    this.seoService.setCanonicalUrl(canonicalUrl);
  }
}
